import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@design-system/Skeleton';
import { LOGO_WHITE } from '@/constants/images';
import { cn } from '@/utils/styles';

export const FullScreenPageContainer = ({
  children,
  footer = null,
  isLoading = false,
  hideBackButton = false,
  centerContent = false,
  previousPath,
}: {
  children: React.ReactNode;
  footer?: React.ReactNode;
  isLoading?: boolean;
  hideBackButton?: boolean;
  centerContent?: boolean;
  previousPath?: string;
}) => {
  const navigate = useNavigate();

  const handleGoBack: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault();
    previousPath ? navigate(previousPath) : navigate(-1);
  };

  return (
    <div className="flex justify-center md:justify-start min-h-screen py-8 md:py-0 bg-primary-foreground">
      <div className="hidden md:flex justify-center w-[244px] bg-black">
        <div>
          <img src={LOGO_WHITE} className="mt-12" />
        </div>
      </div>
      <div className="flex flex-col justify-between flex-1">
        <div
          className={cn(
            'px-5 md:px-24 md:py-8 flex-1',
            centerContent ? 'flex' : '',
          )}
        >
          {hideBackButton ? (
            ''
          ) : (
            <div className={centerContent ? 'self-start' : ''}>
              <a
                onClick={handleGoBack}
                href="#"
                className="text-sm mb-4 inline-block flex items-center ml-[-5px]"
              >
                <ChevronLeft size={24} />
                <span className="hidden md:block ml-1">Back</span>
              </a>
            </div>
          )}
          <div
            className={cn('md:mt-10 flex', centerContent ? 'm-auto' : 'mt-8')}
          >
            <div className="flex-1 md:max-w-2xl">
              {isLoading ? (
                <div className="w-96 flex justify-center">
                  <Skeleton className="size-full" />
                </div>
              ) : (
                children
              )}
            </div>
          </div>
        </div>

        <div>{footer}</div>
      </div>
    </div>
  );
};
